import { defineRecipe } from '@chakra-ui/react';

export const quoteRecipe = defineRecipe({
  className: 'quote',
  base: {
    px: 4,
    py: 2,
    fontSize: '1.2rem',
    bgColor: 'teal.900',
    borderLeft: '4px solid',
    borderColor: 'teal.300',
    borderRightRadius: '.3rem',
  },
});
